(function ($) {
	/**
	 * Sanitise tooltip HTML: only allow <a> tags with href, target, rel.
	 * Strips all other HTML elements to prevent unsafe content.
	 */
	function sanitiseTooltipHTML(html) {
		var div = document.createElement('div');
		div.innerHTML = html;

		var allElements = div.querySelectorAll('*');
		for (var i = 0; i < allElements.length; i++) {
			var el = allElements[i];
			if (el.tagName === 'A') {
				var href = el.getAttribute('href');
				// Remove all attributes first
				while (el.attributes.length > 0) {
					el.removeAttribute(el.attributes[0].name);
				}
				if (href) {
					el.setAttribute('href', href);
					el.setAttribute('target', '_blank');
					el.setAttribute('rel', 'noopener noreferrer');
				}
			} else {
				// Replace element with its text content
				var textNode = document.createTextNode(el.textContent);
				el.parentNode.replaceChild(textNode, el);
			}
		}

		return div.innerHTML;
	}

	// --- Inline image tooltips (title attribute) ---
	// Collect tooltip targets from both:
	//   1. <img title="...">  (default WordPress inline images)
	//   2. <picture title="...">  (webp/avif plugin wraps <img> in <picture>)
	const $tooltipTargets = $('img[title], picture[title]').filter(function () {
		return $(this).attr('title').trim().length > 0;
	});

	if ($tooltipTargets.length) {
		$tooltipTargets.each(function () {
			const $el = $(this);
			const tooltipText = $el.attr('title');
			const isPicture = $el.is('picture');

			// For <picture>, grab the alt from the nested <img>; for <img> use its own alt
			const altText = isPicture ? $el.find('img').attr('alt') || 'Info' : $el.attr('alt') || 'Info';

			// Remove the native title to prevent the browser's default tooltip
			$el.removeAttr('title');

			// Wrap the element in a <button> for keyboard/screen reader accessibility
			const $button = $('<button>', {
				type: 'button',
				class: 'has-tooltip',
				'data-tooltip': tooltipText,
				'aria-label': altText + ' — click for more information',
				css: {
					background: 'none',
					border: 'none',
					padding: 0,
					cursor: 'pointer',
					display: 'inline',
					verticalAlign: 'middle',
					lineHeight: 0,
				},
			});

			$el.wrap($button);
		});

		tippy('.has-tooltip', {
			touch: true,
			trigger: 'click',
			interactive: true,
			aria: {
				content: 'describedby',
			},
			allowHTML: true,
			content(reference) {
				return sanitiseTooltipHTML(reference.getAttribute('data-tooltip'));
			},
		});
	}

	// --- Glossary link tooltips ---
	if (!window.TOOLTIP_URL) {
		return;
	}

	const $glossaryLinks = $(`a[href^="${window.TOOLTIP_URL}"]:not(.tooltip)`);

	// each $glossaryLinks replace it with a <span>
	$glossaryLinks.each(function () {
		const $this = $(this);
		const $span = $('<button>', {
			class: 'tooltip',
			html: $this.html(),
			'data-href': $this.attr('href'),
		});

		$this.replaceWith($span);
	});

	// const $glossaryLinks = $(`a[data-type="glossary-terms"]:not(.tooltip)`);
	if (!$glossaryLinks.length) {
		return;
	}

	let isTouchDevice = false;

	$glossaryLinks.on('touchstart', function () {
		isTouchDevice = true;
	});

	$glossaryLinks.on('click', function (e) {
		if (!this._tippy.state.isShown && isTouchDevice) {
			e.preventDefault();
		}
	});

	tippy('.tooltip', {
		touch: true,
		// trigger: 'mouseenter click touchstart',
		trigger: 'mouseenter click touchstart',
		interactive: true,
		aria: {
			content: 'describedby',
		},
		allowHTML: true,
		onCreate(instance) {
			// Setup our own custom state properties
			instance._isFetching = false;
			instance.setContent('Loading...');
		},
		onShow(instance) {
			if (instance._isFetching) {
				return;
			}

			instance._isFetching = true;

			const $ref = $(instance.reference);

			const url = $ref.attr('data-href');
			let content = 'Could not find definition';

			$.get(url, function AjaxCall(res) {
				const $html = $(res);
				const $definition = $html;

				if ($definition.length) {
					content = $definition.html();
				}

				instance.setContent(content);
			});
		},
	});
})(jQuery);
